<div class="validation-inventaire-container">
  <dx-data-grid
    #grid
    [dataSource]="validations"
    keyExpr="inventaireHistoryId"
    [showBorders]="true"
    [rowAlternationEnabled]="true"
    [allowColumnResizing]="true"
    [columnAutoWidth]="true"
    (onSelectionChanged)="onSelectionChanged($event)"
    (onCellClick)="onInfoAnnexeCellClick($event)"
    (onCellPrepared)="onCellPrepared($event)">

    <dxo-selection mode="multiple" [selectAllMode]="'allPages'" [showCheckBoxesMode]="'always'"></dxo-selection>
    <dxo-header-filter [visible]="true"></dxo-header-filter>

    <dxo-toolbar>
      <dxi-item location="before">
        <div *dxTemplate>
          <yo-button iconClass="fa fa-plus" label="CRÉER" [theme]="ButtonThemeEnum.ADD" (onClick)="onCreate()"></yo-button>
        </div>
      </dxi-item>
      <dxi-item name="groupPanel"></dxi-item>
      <dxi-item name="columnChooserButton"></dxi-item>
      <dxi-item location="after">
        <div *dxTemplate>
          <yo-button [theme]="ButtonThemeEnum.DELETE" iconClass="fa fa-trash" [disabled]="!canDeleteSelection" (onClick)="deleteSelected()"></yo-button>
        </div>
      </dxi-item>
      <dxi-item location="after">
        <div *dxTemplate>
          <yo-button
            label="Valider la sélection"
            iconClass="fa fa-check"
            [theme]="ButtonThemeEnum.SAVE"
            [disabled]="!canApprouveSelection"
            (onClick)="onApprouveSelection()">
          </yo-button>
        </div>
      </dxi-item>
      <dxi-item location="after">
        <div *dxTemplate>
          <yo-button
            label="Invalider la sélection"
            iconClass="fa fa-xmark"
            [theme]="ButtonThemeEnum.DELETE"
            [disabled]="!canInvalideSelection"
            (onClick)="onInvalideSelection()">
          </yo-button>
        </div>
      </dxi-item>
    </dxo-toolbar>

    <dxo-paging [pageSize]="25"></dxo-paging>
    <dxo-pager
      [visible]="true"
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[25, 50, 100, 200]"
      [showNavigationButtons]="true"
      [showInfo]="true"
      infoText="{2} ligne(s)">
    </dxo-pager>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-column-chooser mode="select" [enabled]="true"></dxo-column-chooser>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-group-panel [visible]="true"></dxo-group-panel>
    <dxo-grouping [autoExpandAll]="true"></dxo-grouping>

    <dxi-column caption="Validation" [width]="120"
                [allowFiltering]="false"
                [allowSorting]="false"
                [allowHeaderFiltering]="true"
                [calculateCellValue]="getValidationFilterValue"
                cellTemplate="validationIconTemplate">
      <dxo-header-filter [dataSource]="validationFilterList"></dxo-header-filter>
    </dxi-column>
    <dxi-column dataField="udpLibelle" caption="Unité de production"></dxi-column>
    <dxi-column dataField="inventaireDate" caption="Date inventaire" dataType="date" format="dd/MM/yyyy"></dxi-column>
    <dxi-column dataField="infoAnnexe" caption="Info annexe" [width]="180" [allowFiltering]="false" [allowSorting]="false" cellTemplate="infoAnnexeCellTemplate"></dxi-column>
    <dxi-column dataField="repasCount" caption="Nb repas" dataType="number"></dxi-column>
    <dxi-column dataField="repasCountPondere" caption="Nb repas pondéré" dataType="number" format=",##0.00"></dxi-column>
    <dxi-column dataField="stockInitialAlimentaire" caption="Stock initial alimentaire" dataType="number" format=",##0.00 €"></dxi-column>
    <dxi-column dataField="stockFinalAlimentaire" caption="Stock final alimentaire" dataType="number" format=",##0.00 €"></dxi-column>
    <dxi-column dataField="achatsAmountAlimentaire" caption="Achats alimentaire" dataType="number" format=",##0.00 €"></dxi-column>
    <dxi-column dataField="stockInitialNonAlimentaire" caption="Stock initial non alimentaire" dataType="number" format=",##0.00 €" [visible]="false"></dxi-column>
    <dxi-column dataField="stockFinalNonAlimentaire" caption="Stock final non alimentaire" dataType="number" format=",##0.00 €" [visible]="false"></dxi-column>
    <dxi-column dataField="achatsAmountNonAlimentaire" caption="Achats non alimentaire" dataType="number" format=",##0.00 €"></dxi-column>
    <dxi-column dataField="consommationsAlimentaire" caption="Consommations alimentaire" dataType="number" format=",##0.00 €"></dxi-column>
    <dxi-column dataField="consommationsNonAlimentaire" caption="Consommations non alimentaire" dataType="number" format=",##0.00 €" [visible]="false"></dxi-column>
    <dxi-column dataField="coutMoyenRepas" caption="Coût moyen repas" dataType="number" format=",##0.00 €"></dxi-column>
    <dxi-column dataField="coutMoyenRepasPondere" caption="Coût moyen repas pondéré" dataType="number" format=",##0.00 €"></dxi-column>
    <dxi-column dataField="coutCibleMoyenPondere" caption="Coût cible moyen pondéré" dataType="number" format=",##0.00 €"></dxi-column>
    <dxi-column dataField="creePar" caption="Créé par"></dxi-column>
    <dxi-column dataField="dateCreation" caption="Date création" dataType="datetime" format="dd/MM/yyyy HH:mm"></dxi-column>
    <dxi-column dataField="validationNiv1Par" caption="Validé niv.1 par"></dxi-column>
    <dxi-column dataField="dateValidationNiv1" caption="Date valid. niv.1" dataType="datetime" format="dd/MM/yyyy HH:mm"></dxi-column>
    <dxi-column dataField="validationNiv2Par" caption="Validé niv.2 par" [visible]="false"></dxi-column>
    <dxi-column dataField="dateValidationNiv2" caption="Date valid. niv.2" dataType="datetime" format="dd/MM/yyyy HH:mm" [visible]="false"></dxi-column>
    <dxi-column dataField="validationNiv3Par" caption="Validé niv.3 par" [visible]="false"></dxi-column>
    <dxi-column dataField="dateValidationNiv3" caption="Date valid. niv.3" dataType="datetime" format="dd/MM/yyyy HH:mm" [visible]="false"></dxi-column>

    <div *dxTemplate="let cell of 'validationIconTemplate'" class="validation-icon-cell">
      <yo-icon
        [icon]="cell.row.data.validationNiv1Par ? 'fa-circle-check' : 'fa-circle'"
        [theme]="getValidationTheme(cell.row.data, 1)"
        [title]="getValidationTitle(cell.row.data, 1)"
        variant="regular">
      </yo-icon>
      <yo-icon
        [icon]="cell.row.data.validationNiv2Par ? 'fa-circle-check' : 'fa-circle'"
        [theme]="getValidationTheme(cell.row.data, 2)"
        [title]="getValidationTitle(cell.row.data, 2)"
        [class.not-visible]="!(hasNiv2 || hasNiv3 || cell.row.data.validationNiv2Par)"
        variant="regular">
      </yo-icon>
      <yo-icon
        [icon]="cell.row.data.validationNiv3Par ? 'fa-circle-check' : 'fa-circle'"
        [theme]="getValidationTheme(cell.row.data, 3)"
        [title]="getValidationTitle(cell.row.data, 3)"
        [class.not-visible]="!(hasNiv3 || cell.row.data.validationNiv3Par)"
        variant="regular">
      </yo-icon>
      @if (cell.row.data.dateFacturationClient) {
        <yo-icon icon="fa-file-invoice-dollar"
                 [theme]="IconThemeEnum.WARNING_INNER"
                 variant="solid"
                 [title]="'Facture datant du ' + (cell.row.data.dateFacturationClient | date:'dd/MM/yyyy')">
        </yo-icon>
      }
    </div>

    <div *dxTemplate="let cell of 'infoAnnexeCellTemplate'" class="info-annexe-cell">
      @if (cell.row.data.infoAnnexe) {
        <yo-icon icon="comments" [theme]="IconThemeEnum.WARNING_INNER" variant="solid"></yo-icon>
        {{ getFirstLine(cell.row.data.infoAnnexe) }}
      } @else if (isEditable(cell.row.data)) {
        <yo-button size="small" [theme]="ButtonThemeEnum.DEFAULT_INNER"
                   iconClass="fa fa-edit" tooltip="Saisir une info annexe"
                   (onClick)="openInfoAnnexeDialog(cell.row.data)">
        </yo-button>
      }
    </div>

  </dx-data-grid>
</div>

<dx-popup
  title="Validations non supprimées"
  [visible]="displayDeletePopupErrors"
  [height]="'auto'"
  [resizeEnabled]="true"
  [showCloseButton]="true"
  (onHidden)="closeErrors()">
  <div *dxTemplate="let data of 'content'" class="error-container">
    <p>Ces validations n'ont pas pu être supprimées car elles sont déjà validées.</p>
    <dx-data-grid [dataSource]="errors" keyExpr="infosLine" [showBorders]="true">
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxi-column dataField="infosLine" caption="Validation non supprimée"></dxi-column>
    </dx-data-grid>
  </div>
</dx-popup>

<dx-popup
  [(visible)]="displayInfoAnnexeDialog"
  [showCloseButton]="true"
  [dragEnabled]="true"
  [width]="700"
  [height]="450"
  title="Info annexe">
  <div class="popup-content">
    <dx-html-editor [(value)]="infoAnnexeValue" height="280" [readOnly]="infoAnnexeReadOnly">
      @if (!infoAnnexeReadOnly) {
        <dxo-toolbar>
          <dxi-item name="bold"></dxi-item>
          <dxi-item name="italic"></dxi-item>
          <dxi-item name="underline"></dxi-item>
          <dxi-item name="separator"></dxi-item>
          <dxi-item name="orderedList"></dxi-item>
          <dxi-item name="bulletList"></dxi-item>
          <dxi-item name="separator"></dxi-item>
          <dxi-item name="clear"></dxi-item>
        </dxo-toolbar>
      }
    </dx-html-editor>
    @if (!infoAnnexeReadOnly) {
      <div class="popup-footer">
        <yo-button label="Enregistrer" iconClass="fa fa-save"
                   [theme]="ButtonThemeEnum.SAVE"
                   (onClick)="onSaveInfoAnnexe()">
        </yo-button>
      </div>
    }
  </div>
</dx-popup>

<dx-popup
  [(visible)]="displayCreateDialog"
  [showCloseButton]="true"
  [dragEnabled]="true"
  [height]="'auto'"
  [width]="400"
  title="Nouvelle validation de fin de mois">

  <div class="popup-content">
    <div class="field">
      <label>Unité de production</label>
      <yo-lookup
        [data]="udpList"
        displayValue="libelle"
        key="id"
        [selectedItem]="selectedUdpId"
        placeholder="Sélectionner..."
        width="100%"
        (onValueChange)="onUdpChange($event)">
      </yo-lookup>
    </div>

    <div class="field">
      <label>Mois</label>
      <yo-lookup
        [data]="monthList"
        displayValue="label"
        key="inventaireHistoryId"
        [selectedItem]="selectedHistoryId"
        placeholder="Sélectionner..."
        [disabled]="!selectedUdpId"
        width="100%"
        (onValueChange)="selectedHistoryId = $event">
      </yo-lookup>
    </div>

    <div class="popup-footer">
      <yo-button
        label="Valider"
        iconClass="fa fa-check"
        [theme]="ButtonThemeEnum.SAVE"
        [disabled]="!selectedHistoryId"
        (onClick)="onSave()">
      </yo-button>
    </div>
  </div>

</dx-popup>
